import { combineReducers } from "redux"
import profile from "./profile"
import alerts from "./alerts"
import analytics from "./analytics"
import shardedAnalytics from "./shardedAnalytics"
import stock from "./tabularData/stock"
import sales from "./tabularData/sales"
import inventories from "./tabularData/inventories"
import purchases from "./tabularData/purchases"
import employees from "./employees"
import inventory from "./tabularData/inventory"
import salesReport from "./tabularData/salesReport"
import cashbox from "./cashbox"
import measures from "./measures"
import discounts from "./discounts"
import userData from "./userAuthData"
import alkashka from "./alcohol"
import products from "./products"
import product from "./product"
import payment from "./payment"
import shardedAnalyticsNew from "./shardedAnalyticsNew"

export default combineReducers({
  profile,
  alerts,
  analytics,
  shardedAnalytics,
  stock,
  sales,
  discounts,
  salesReport,
  purchases,
  employees,
  inventories,
  currentInventory: inventory,
  cashbox,
  measures,
  userData,
  alkashka,
  products,
  product,
  payment,
  shardedAnalyticsNew,
})
